<template>
  <ul class="list_slat_container">
    <li class="list_slat_item"
      :key="id"
      v-for="{id, category, width, height, parts, washable, ...meta} in filteredSlats"
      @click.stop="updateItem(category, id, width, height, parts, meta)"
    >
      <figure class="list_slat_wrapper" :class="{ selected: isSelected(id) }">
        <img class="list_slat_img" @error="noImg($event)" :src="`item_image/curtain/repeat/${prefix}/thumb/${id}.jpg`" width="90" height="90" loading="lazy" />
        <figcaption class="list_slat_name" :class="{ washable: meta.washable }">
          <span
            class="slat_code"
            :class="{ washable }"
          >{{ getShowName(id, meta) }}</span>
          <span
            class="slat_name"
            :class="[
              Object.hasOwn(meta, 'fireproof')
                ? meta.fireproof
                  ? 'fireproof'
                  : 'not_fireproof'
                : '',
            ]"
          >{{ meta.name }}</span>
        </figcaption>
      </figure>
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { getUpdateSuffix } from '../../../assets/js/state_util'

export default {
  props: {
    slats: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('simulator', ['slat_list']),
    ...mapGetters('simulator', ['editing_item', 'feature', 'editing_productType', 'slat_category','disabled_ctg_id']),
    prefix () {
      return this.editing_item.prefix
    },
    targetProp () {
      return this.editing_item.secondaryTarget
        ? `name${getUpdateSuffix(this.editing_productType, this.feature.type)}`
        : 'name'
    },
    isSelected () {
      return (id) => this.editing_item.item_data?.[this.targetProp] === id
    },
    filteredSlats () {
      // ペア製品のドレープスロット選択中（disabled_ctg_idに'lace'が含まれる）は
      // attrib: 'lace' のアイテムを非表示にする
      if (this.disabled_ctg_id.includes('lace')) {
        return this.slats.filter(({ attrib }) => attrib !== 'lace')
      }
      // レーススロット選択中で、通常は非表示のカテゴリ（attrib: 'lace'のために表示中）は
      // attrib: 'lace' のアイテムのみ表示する
      if (this.slats.length > 0 && this.disabled_ctg_id.includes(this.slats[0].ctgId)) {
        return this.slats.filter(({ attrib }) => attrib === 'lace')
      }
      return this.slats
    }
  },
  methods: {
    ...mapMutations(['setModal', 'toggleMoM', 'setMoMFunc']),
    // ...mapMutations('simulator', []),
    ...mapActions('simulator', ['updateItemInfo', 'setSlatCtgSelected', 'reverseSlatPairing']),
    async updateItem(ctg, id, width, height, parts, meta) {
      if (meta.attrib !== 'lace' && this.disabled_ctg_id.includes(meta.ctgId)) {
        this.toggleMoM();
        const pass = await new Promise(
            (resolve, reject) => this.setMoMFunc([resolve, reject])
          ).then(async () => { await this.reverseSlatPairing(); return true; })
          .catch(() => { this.toggleMoM(); return false; } );
        if (!pass) { return; }
      }
      this.setSlatCtgSelected(this.slat_category.find(({name}) => name === ctg))
      await this.updateItemInfo({
        progress: 2,
        item_data: {
          name: id,
          width,
          height,
          ctgId: meta.ctgId,
          attrib: meta.attrib
        },
        disable_parts: meta?.disable_parts,
        weight_bar: meta?.weight_bar,
        ...(meta?.feature?.type === 'weightBar' ? { feature: meta.feature } : {}),
        ...(typeof meta.shield !== 'undefined' ? { shield: meta.shield } : {}),
        parts
      })

      // 以下条件のみ、recommend に設定された生地に反対側の生地を切り替える
      if ((this.prefix === 'PS' && this.editing_item.feature?.type === 'topBottom')
          || this.editing_productType == 'LD-PE-100') {

        if (meta.recommend && !this.editing_item.laceChanged) {
          const { recommend } = meta
          const { id: name, width, height, ctgId, attrib } = this.slat_list.find(({id}) => id === recommend)

          const sfx = this.editing_item.secondaryTarget ? '' : this.prefix == 'PS' ? '_bottom' : '_lace'
          await this.updateItemInfo({
            item_data: {
              [`name${sfx}`]: name,
              [`width${sfx}`]: width,
              [`height${sfx}`]: height,
              [`ctgId${sfx}`]: ctgId, // lace
              [`attrib${sfx}`]: attrib
            },
            recommend: true
          })
        } else {
          await this.updateItemInfo({
            laceChanged: true
          })
        }
      }

      this.setModal('')
    },
    getShowName (id, { display }) {
      // 'PL'ではじまる productType 以外の時は基本的にdisplayを使用する
      const useDisplayProp = !this.editing_productType.startsWith('PL')
      return useDisplayProp ? (display || id) : id
    },
    noImg (ev) {
      ev.target.src = 'assets/parts/category/na.svg'
    }
  }
}
</script>

<style lang="scss">
  .list_slat_container {
    display: flex;
    flex-flow: row wrap;
    padding: 0;
    .list_slat_item {
      margin: calc(5 / 300 * 100%) calc(2.5 / 300 * 100%);
      flex: 0 0 auto;
      flex-basis: calc(45 / 300 * 100%);
      list-style: none;
      cursor: pointer;
      .list_slat_wrapper {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0;
        &.selected {
          outline: 2px solid #000;
          border-radius: 4px;
        }
        .list_slat_img {
          width: 100%;
          height: auto;
        }
        .list_slat_name {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          padding-block-end: 4px;
          .slat_code.washable {
            color: #00A0E9;
          }
          .slat_name {
            font-size: 0.5em;
            line-height: 1.5;
            &:where([class*=' '])::before {
              display: inline-block;
              content: '';
              margin-right: 1px;
              aspect-ratio: 6.7 / 2.7;
              width: auto;
              height: 1lh;
              vertical-align: middle;
              // background: {
              //   repeat: no-repeat;
              //   position: center;
              //   size: contain;
              // }
            }
            &.not_fireproof::before {
              content: url(../../../assets/img/parts/icon_not_firep.svg);
            }
            &.fireproof::before {
              content: url(../../../assets/img/parts/icon_firep.svg);
            }
          }
        }
      }
    }
  }
</style>